// extracted by mini-css-extract-plugin
module.exports = {"content":"PayDialog_content__TZU8X","loading":"PayDialog_loading__Gigp8","backButton":"PayDialog_backButton__0askL","dialogTitle":"PayDialog_dialogTitle__8xAbs"};